import { Space, Tooltip, Tag, Switch } from "antd";
import { useState } from "react";

import styles from "../components/MasterManagement/index.module.less";
import { Actions, ModuleAndIdMapping, Modules, Operations } from "../constants/DatabaseConstants/MasterConstant";
import { TableHelper } from "../util/TableHelper";
import Authentication from "../util/Authentication";
import { LocalStorageConstants } from "../constants/ApplicationConstants/LocalStorageConstants";
import LocalStorageUtil from "../util/LocalStorageUtil";
import { UserRoleDATA } from "../constants/DatabaseConstants/AuthConstants";
import CustomPopoverActions from "../components/common/CustomPopoverActions";

import type { TableColumn } from "../shared/interface/MissedEntries.interface";
import type { UserInterface } from "../shared/interface/auth/User.interface";
import type FixMeLater from "../shared/types/fixMeLater.type";
import { ConfigMasterConstants } from "../constants/DatabaseConstants/ConfigMasterConstants";

const rowClassName = (record: any) => {
  if (record?.is_visitor) {
    return `${styles["highlighted-record-isVisitor"]}`;
  } else {
    return "";
  }
};

/* helper function to highlight row */
const renderText = (value: FixMeLater) => (
  <span style={{ wordWrap: "break-word", wordBreak: "break-word" }} className="gx-link entity-name-selected">
    {String(value)}
  </span>
);

const renderTextContainer = (text: FixMeLater) => {
  const fullText = String(TableHelper.getValue(text));
  const truncatedText = fullText.length > 50 ? `${fullText.slice(0, 50)}...` : fullText;

  return (
    <Tooltip title={fullText}>
      <div className="wordWrapWordBreak">{truncatedText}</div>
    </Tooltip>
  );
};

// const renderTextContainer = (text: FixMeLater) => {
//   return <div className="wordWrapWordBreak">{TableHelper.getValue(text)}</div>;
// };

const renderNumberValue = (text: string | number) => {
  return <div className="gx-text-right wordWrapWordBreak">{TableHelper.getValue(text)}</div>;
};

const CommonActionComponent = ({ handleRowIdAndActionType, record, moduleId }: FixMeLater) => {
  /* CONSTANT */
  const userData = LocalStorageUtil.localStorageGetItem(LocalStorageConstants.USER_DATA) as UserInterface;

  const isEditActionAvailable = moduleId !== ModuleAndIdMapping[Modules.ADVANCE_BOOKING_QUOTA_MASTER] && record?.rolename !== UserRoleDATA.PARI_ADMIN && Authentication.checkModuleAccessById(userData, moduleId, Operations.UPDATE) && record?.name !== ConfigMasterConstants.MINS_BEFORE_SENDING_NOTIF;

  const isDeleteActionAvailable = moduleId !== ModuleAndIdMapping[Modules.KEY_FOB_ALLOCATION_MASTER] && moduleId !== ModuleAndIdMapping[Modules.ADVANCE_BOOKING_QUOTA_MASTER] && record?.rolename !== UserRoleDATA.PARI_ADMIN && Authentication.checkModuleAccessById(userData, moduleId, Operations.DELETE);

  const isDeleteActionAvailableKeyFobAllocation = moduleId === ModuleAndIdMapping[Modules.KEY_FOB_ALLOCATION_MASTER] && Authentication.checkModuleAccessById(userData, moduleId, Operations.DELETE);

  const isDeleteActionAvailableAdvanceBookingQuota = moduleId === ModuleAndIdMapping[Modules.ADVANCE_BOOKING_QUOTA_MASTER] && Authentication.checkModuleAccessById(userData, moduleId, Operations.DELETE);

  /* Master Redirection  */
  const redirectAccessModules = [ModuleAndIdMapping[Modules.CUSTOMER_MASTER], ModuleAndIdMapping[Modules.CUSTOMER_LOCATION_MASTER], ModuleAndIdMapping[Modules.CUSTOMER_CLIENT_MASTER], ModuleAndIdMapping[Modules.KEY_FOB_ALLOCATION_MASTER], ModuleAndIdMapping[Modules.KEY_FOB_MASTER], ModuleAndIdMapping[Modules.PRICING_MASTER]];
  const isMasterRedirectActionsAvailable = redirectAccessModules.includes(moduleId);

  return (
    <Space>
      {/* edit button */}
      {isEditActionAvailable && <Tooltip title="Edit">{record?.is_active ? <i onClick={handleRowIdAndActionType.bind(this, record.id, Actions.EDIT, record)} className={`icon icon-edit gx-link ${styles["action-icon"]} `} /> : <i className={`icon icon-edit  icon-disabled ${styles["action-icon"]} `} />}</Tooltip>}
      {moduleId === ModuleAndIdMapping[Modules.ADVANCE_BOOKING_QUOTA_MASTER] && (
        <Tooltip title="Edit">
          <i onClick={handleRowIdAndActionType.bind(this, record.id, Actions.EDIT, record)} className={`icon icon-edit gx-link ${styles["action-icon"]} `} />
        </Tooltip>
      )}

      {/* delete button */}
      {isDeleteActionAvailable && (
        <Tooltip title={record?.is_active ? "Active" : "In-Active"}>
          <span className={"link"}>
            <Switch checked={record?.is_active} onChange={handleRowIdAndActionType.bind(this, record.id, Actions.DELETE, record)} />
          </span>
        </Tooltip>
      )}

      {/* delete button only keyFob Allocation master*/}
      {(isDeleteActionAvailableKeyFobAllocation || isDeleteActionAvailableAdvanceBookingQuota) && (
        <Tooltip title="Delete">
          <i onClick={handleRowIdAndActionType.bind(this, record.id, Actions.DELETE, record)} className={`icon icon-trash gx-link ${styles["action-icon"]} `} />
        </Tooltip>
      )}

      {/* Master Redirect Actions */}
      {isMasterRedirectActionsAvailable && <CustomPopoverActions moduleId={moduleId} record={record} />}
    </Space>
  );
};

const ConfigMasterColumns = (moduleId: number, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%"
    },
    {
      align: "left",
      title: "Key",
      dataIndex: "name",
      key: "name",
      sorter: {
        compare: TableHelper.valueCompare("name")
      },
      render: (text, record) => <div className="wordWrapWordBreak ">{rowId === record.id && (actionType === Actions.DELETE || actionType === Actions.EDIT) ? renderText(text) : text ?? ""}</div>
    },
    {
      align: "left",
      title: "Value",
      dataIndex: "value",
      key: "value",
      sorter: {
        compare: TableHelper.valueCompare("value")
      },
      render: renderTextContainer,
      width: "7%"
    },
    {
      align: "left",
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: {
        compare: TableHelper.valueCompare("description")
      },
      render: (text, record) => (
        <div className="wordWrapWordBreak" style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {text}
        </div>
      )
    },
    {
      align: "left",
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      render: (text, record) => {
        return <CommonActionComponent handleRowIdAndActionType={handleRowIdAndActionType} record={record} moduleId={moduleId} />;
      }
    }
  ] as TableColumn[];
};

const RoleMasterColumns = (moduleId: number, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%"
    },
    {
      align: "left",
      title: "Role Name",
      dataIndex: "rolename",
      key: "rolename",
      sorter: {
        compare: TableHelper.valueCompare("rolename")
      },
      render: (text, record) => <div className="wordWrapWordBreak">{rowId === record.id && (actionType === Actions.DELETE || actionType === Actions.EDIT) ? renderText(text) : text ?? ""}</div>
    },
    {
      align: "left",
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: {
        compare: TableHelper.valueCompare("description")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Hierarchy Level",
      dataIndex: "hierarchy_level",
      key: "hierarchy_level",
      sorter: {
        compare: TableHelper.valueCompare("hierarchy_level")
      },
      render: (text) => <div>{`Level ${text ?? " "}`}</div>
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: {
        compare: TableHelper.valueCompare("is_active")
      },
      render: (text) => <div>{text === true ? <Tag color="success">Active</Tag> : <Tag color="error">In-Active</Tag>}</div>
    },
    {
      align: "left",
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      render: (text, record) => {
        return <CommonActionComponent handleRowIdAndActionType={handleRowIdAndActionType} record={record} moduleId={moduleId} />;
      }
    }
  ] as TableColumn[];
};

const AccessControlMasterColumns = (moduleId: number, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%"
    },
    {
      align: "left",
      title: "Role Name",
      dataIndex: "role_name",
      key: "role_name",
      sorter: {
        compare: TableHelper.valueCompare("role_name")
      },
      render: (text, record) => <div className="wordWrapWordBreak">{rowId === record.id && (actionType === Actions.DELETE || actionType === Actions.EDIT) ? renderText(text) : text ?? ""}</div>
    },
    {
      align: "left",
      title: "Module Name",
      dataIndex: "module_name",
      key: "module_name",
      sorter: {
        compare: TableHelper.valueCompare("module_name")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Operations",
      dataIndex: "operation_names",
      key: "operation_names",
      sorter: {
        compare: TableHelper.valueCompare("operation_names")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      fixed: "right",
      sorter: {
        compare: TableHelper.valueCompare("is_active")
      },
      render: (text, record) => <div>{text === true ? <Tag color="success">Active</Tag> : <Tag color="error">In-Active</Tag>}</div>
    }
  ] as TableColumn[];
};

const CustomerMasterColumns = (moduleId: number, handleSetImagePath: (value: string | null) => void, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%"
    },
    {
      align: "left",
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      },
      render: (text, record) => <div className="wordWrapWordBreak">{rowId === record.id && (actionType === Actions.DELETE || actionType === Actions.EDIT) ? renderText(text) : text ?? ""}</div>
    },
    {
      align: "left",
      title: "Corporate Address",
      dataIndex: "address",
      key: "address",
      sorter: {
        compare: TableHelper.valueCompare("address")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Contact Person",
      dataIndex: "contact_person",
      key: "contact_person",
      sorter: {
        compare: TableHelper.valueCompare("contact_person")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Email Address",
      dataIndex: "email_address",
      key: "email_address",
      sorter: {
        compare: TableHelper.valueCompare("email_address")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Mobile Number",
      dataIndex: "mobile_number",
      key: "mobile_number",
      sorter: {
        compare: TableHelper.valueCompare("mobile_number")
      },
      render: renderNumberValue
    },
    {
      align: "left",
      title: "Logo",
      dataIndex: "logo_url",
      key: "logo_url",
      render: (text, record) => (
        <>
          <Tooltip title="Preview image">
            <i onClick={() => handleSetImagePath(text)} className={`icon icon-image gx-link ${styles["logo-image-icon"]} `} />
          </Tooltip>
        </>
      )
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: {
        compare: TableHelper.valueCompare("is_active")
      },
      render: (text, record) => <div>{text === true ? <Tag color="success">Active</Tag> : <Tag color="error">In-Active</Tag>}</div>
    },
    {
      align: "left",
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      render: (text, record) => {
        return <CommonActionComponent handleRowIdAndActionType={handleRowIdAndActionType} record={record} moduleId={moduleId} />;
      }
    }
  ] as TableColumn[];
};

const LocationTypeMasterColumns = (moduleId: number, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%"
    },
    {
      align: "left",
      title: "Location Type",
      dataIndex: "location_type_name",
      key: "location_type_name",
      sorter: {
        compare: TableHelper.valueCompare("location_type_name")
      },
      render: (text, record) => <div className="wordWrapWordBreak">{rowId === record.id && (actionType === Actions.DELETE || actionType === Actions.EDIT) ? renderText(text) : text ?? ""}</div>
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: {
        compare: TableHelper.valueCompare("is_active")
      },
      render: (text, record) => <div>{text === true ? <Tag color="success">Active</Tag> : <Tag color="error">In-Active</Tag>}</div>
    },
    {
      align: "left",
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      render: (text, record) => {
        return <CommonActionComponent handleRowIdAndActionType={handleRowIdAndActionType} record={record} moduleId={moduleId} />;
      }
    }
  ] as TableColumn[];
};

const ParkingMapTypeMasterColumns = (moduleId: number, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%"
    },
    {
      align: "left",
      title: "Parking Map Type",
      dataIndex: "parking_map_type_name",
      key: "parking_map_type_name",
      sorter: {
        compare: TableHelper.valueCompare("parking_map_type_name")
      },
      render: (text, record) => <div className="wordWrapWordBreak">{rowId === record.id && (actionType === Actions.DELETE || actionType === Actions.EDIT) ? renderText(text) : text ?? ""}</div>
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: {
        compare: TableHelper.valueCompare("is_active")
      },
      render: (text, record) => <div>{text === true ? <Tag color="success">Active</Tag> : <Tag color="error">In-Active</Tag>}</div>
    },
    {
      align: "left",
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      render: (text, record) => {
        return <CommonActionComponent handleRowIdAndActionType={handleRowIdAndActionType} record={record} moduleId={moduleId} />;
      }
    }
  ] as TableColumn[];
};

const CustomerLocationMasterColumns = (moduleId: number, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%"
    },
    {
      align: "left",
      title: "Location",
      dataIndex: "location_name",
      key: "location_name",
      sorter: {
        compare: TableHelper.valueCompare("location_name")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      },
      render: (text, record) => <div className="wordWrapWordBreak">{rowId === record.id && (actionType === Actions.DELETE || actionType === Actions.EDIT) ? renderText(text) : text ?? ""}</div>
    },
    {
      align: "left",
      title: "Project ID / Device ID",
      dataIndex: "projectId_deviceId",
      key: "projectId_deviceId",
      sorter: {
        compare: TableHelper.valueCompare("projectId_deviceId")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Location Type",
      dataIndex: "location_type_name",
      key: "location_type_name",
      sorter: {
        compare: TableHelper.valueCompare("location_type_name")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Parking Map Type",
      dataIndex: "parking_map_type_name",
      key: "parking_map_type_name",
      sorter: {
        compare: TableHelper.valueCompare("parking_map_type_name")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Location Address",
      dataIndex: "location_address",
      key: "location_address",
      sorter: {
        compare: TableHelper.valueCompare("location_address")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Contact Person",
      dataIndex: "contact_person",
      key: "contact_person",
      sorter: {
        compare: TableHelper.valueCompare("contact_person")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Email Address",
      dataIndex: "email_address",
      key: "email_address",
      sorter: {
        compare: TableHelper.valueCompare("email_address")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Mobile Number",
      dataIndex: "mobile_number",
      key: "mobile_number",
      sorter: {
        compare: TableHelper.valueCompare("mobile_number")
      },
      render: renderNumberValue
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: {
        compare: TableHelper.valueCompare("is_active")
      },
      render: (text, record) => <div>{text === true ? <Tag color="success">Active</Tag> : <Tag color="error">In-Active</Tag>}</div>
    },
    {
      align: "lef",
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      render: (text, record) => {
        return <CommonActionComponent handleRowIdAndActionType={handleRowIdAndActionType} record={record} moduleId={moduleId} />;
      }
    }
  ] as TableColumn[];
};

const CustomerClientMasterColumns = (moduleId: number, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%"
    },
    {
      align: "left",
      title: "Client",
      dataIndex: "client_name",
      key: "client_name",
      sorter: {
        compare: TableHelper.valueCompare("client_name")
      },
      render: (text, record) => <div className="wordWrapWordBreak">{rowId === record.id && (actionType === Actions.DELETE || actionType === Actions.EDIT) ? renderText(text) : text ?? ""}</div>
    },
    {
      align: "left",
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Location",
      dataIndex: "location_name",
      key: "location_name",
      sorter: {
        compare: TableHelper.valueCompare("location_name")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Allocated Parking",
      dataIndex: "allocated_parking",
      key: "allocated_parking",
      sorter: {
        compare: TableHelper.valueCompare("allocated_parking")
      },
      render: renderNumberValue,
      width: "10%"
    },
    {
      align: "left",
      title: "Client Contact",
      dataIndex: "client_contact",
      key: "client_contact",
      sorter: {
        compare: TableHelper.valueCompare("client_contact")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Email Address",
      dataIndex: "email_address",
      key: "email_address",
      sorter: {
        compare: TableHelper.valueCompare("email_address")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Mobile Number",
      dataIndex: "mobile_number",
      key: "mobile_number",
      sorter: {
        compare: TableHelper.valueCompare("mobile_number")
      },
      render: renderNumberValue
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: {
        compare: TableHelper.valueCompare("is_active")
      },
      render: (text, record) => <div>{text === true ? <Tag color="success">Active</Tag> : <Tag color="error">In-Active</Tag>}</div>
    },
    {
      align: "lef",
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      render: (text, record) => {
        return <CommonActionComponent handleRowIdAndActionType={handleRowIdAndActionType} record={record} moduleId={moduleId} />;
      }
    }
  ] as TableColumn[];
};

const KeyFobMasterColumns = (moduleId: number, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%"
    },
    {
      align: "left",
      title: "KeyFob Token",
      dataIndex: "key_fob_token",
      key: "key_fob_token",
      sorter: {
        compare: TableHelper.valueCompare("key_fob_token")
      },
      render: (text, record) => <div className="gx-text-right wordWrapWordBreak">{rowId === record.id && (actionType === Actions.DELETE || actionType === Actions.EDIT) ? TableHelper.getValue(text) : TableHelper.getValue(text)}</div>,
      width: "10%"
    },
    {
      align: "left",
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Location",
      dataIndex: "location_name",
      key: "location_name",
      sorter: {
        compare: TableHelper.valueCompare("location_name")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Vehicle Type",
      dataIndex: "vehicle_type_name",
      key: "vehicle_type_name",
      sorter: {
        compare: TableHelper.valueCompare("vehicle_type_name")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Vehicle Dimensions",
      dataIndex: "dimension",
      key: "dimension",
      sorter: {
        compare: TableHelper.valueCompare("dimension")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Parking Status",
      dataIndex: "parkingStatusName",
      key: "parkingStatusName",
      sorter: {
        compare: TableHelper.valueCompare("parkingStatusName")
      },
      render: (text) => {
        if (!text) return "";
        return renderTextContainer(text.toUpperCase());
      }
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: {
        compare: TableHelper.valueCompare("is_active")
      },
      render: (text, record) => <div>{text === true ? <Tag color="success">Active</Tag> : <Tag color="error">In-Active</Tag>}</div>
    },
    {
      align: "lef",
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      render: (text, record) => {
        return <CommonActionComponent handleRowIdAndActionType={handleRowIdAndActionType} record={record} moduleId={moduleId} />;
      }
    }
  ] as TableColumn[];
};

const KeyFobAllocationMasterColumns = (moduleId: number, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%",
      onCell: (record) => ({
        className: rowClassName(record)
      })
    },
    {
      align: "left",
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      },
      render: (text, record) => <div className="wordWrapWordBreak">{rowId === record.id && (actionType === Actions.DELETE || actionType === Actions.EDIT) ? renderText(text) : text ?? ""}</div>,
      onCell: (record) => ({
        className: rowClassName(record)
      })
    },
    {
      align: "left",
      title: "Location",
      dataIndex: "location_name",
      key: "location_name",
      sorter: {
        compare: TableHelper.valueCompare("location_name")
      },
      render: renderTextContainer,
      onCell: (record) => ({
        className: rowClassName(record)
      })
    },
    {
      align: "left",
      title: "Client",
      dataIndex: "client_name",
      key: "client_name",
      sorter: {
        compare: TableHelper.valueCompare("client_name")
      },
      render: renderTextContainer,
      onCell: (record) => ({
        className: rowClassName(record)
      })
    },
    {
      align: "left",
      title: "KeyFob Token",
      dataIndex: "key_fob_token",
      key: "key_fob_token",
      sorter: {
        compare: TableHelper.valueCompare("key_fob_token")
      },
      render: renderNumberValue,
      width: "10%",
      onCell: (record) => ({
        className: rowClassName(record)
      })
    },
    {
      align: "left",
      title: "Parking Status",
      dataIndex: "parkingStatusName",
      key: "parkingStatusName",
      sorter: {
        compare: TableHelper.valueCompare("parkingStatusName")
      },
      render: (text) => {
        if (!text) return "";
        return renderTextContainer(text.toUpperCase());
      },
      onCell: (record) => ({
        className: rowClassName(record)
      })
    },
    {
      align: "left",
      title: "Username",
      dataIndex: "mobile_portal_user_name",
      key: "mobile_portal_user_name",
      sorter: {
        compare: TableHelper.valueCompare("mobile_portal_user_name")
      },
      render: renderTextContainer,
      onCell: (record) => ({
        className: rowClassName(record)
      })
    },
    {
      align: "left",
      title: "Mobile Number",
      dataIndex: "mobile_number",
      key: "mobile_number",
      sorter: {
        compare: TableHelper.valueCompare("mobile_number")
      },
      render: renderNumberValue,
      onCell: (record) => ({
        className: rowClassName(record)
      })
    },
    {
      align: "left",
      title: "Assigned By",
      dataIndex: "assigned_by",
      key: "assigned_by",
      sorter: {
        compare: TableHelper.valueCompare("assigned_by")
      },
      render: renderTextContainer,
      onCell: (record) => ({
        className: rowClassName(record)
      })
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: {
        compare: TableHelper.valueCompare("is_active")
      },
      render: (text, record) => <div>{text === true ? <Tag color="success">Assigned</Tag> : ""}</div>,
      onCell: (record) => ({
        className: rowClassName(record)
      })
    },
    {
      align: "lef",
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      render: (text, record) => {
        return <CommonActionComponent handleRowIdAndActionType={handleRowIdAndActionType} record={record} moduleId={moduleId} />;
      }
    }
  ] as TableColumn[];
};

const PricingMasterColumns = (moduleId: number, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%"
    },
    {
      align: "left",
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Location",
      dataIndex: "location_name",
      key: "location_name",
      sorter: {
        compare: TableHelper.valueCompare("location_name")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Vehicle Type",
      dataIndex: "vehicle_type_name",
      key: "vehicle_type_name",
      sorter: {
        compare: TableHelper.valueCompare("vehicle_type_name")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Price Per Hour",
      dataIndex: "price_per_hour",
      key: "price_per_hour",
      sorter: {
        compare: TableHelper.valueCompare("price_per_hour")
      },
      render: renderNumberValue
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: {
        compare: TableHelper.valueCompare("is_active")
      },
      render: (text, record) => <div>{text === true ? <Tag color="success">Active</Tag> : <Tag color="error">In-Active</Tag>}</div>
    },
    {
      align: "lef",
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      render: (text, record) => {
        return <CommonActionComponent handleRowIdAndActionType={handleRowIdAndActionType} record={record} moduleId={moduleId} />;
      }
    }
  ] as TableColumn[];
};

const FaqMasterColumns = (moduleId: number, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%"
    },
    {
      align: "left",
      title: "Question",
      dataIndex: "question",
      key: "question",
      sorter: {
        compare: TableHelper.valueCompare("question")
      },
      render: (text, record) => <div className="wordWrapWordBreak">{rowId === record.id && (actionType === Actions.DELETE || actionType === Actions.EDIT) ? renderText(text) : text ?? ""}</div>
    },
    {
      align: "left",
      title: "Answer",
      dataIndex: "answer",
      key: "answer",
      sorter: {
        compare: TableHelper.valueCompare("answer")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: {
        compare: TableHelper.valueCompare("is_active")
      },
      render: (text, record) => <div>{text === true ? <Tag color="success">Active</Tag> : <Tag color="error">In-Active</Tag>}</div>
    },
    {
      align: "left",
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      render: (text, record) => {
        return <CommonActionComponent handleRowIdAndActionType={handleRowIdAndActionType} record={record} moduleId={moduleId} />;
      }
    }
  ] as TableColumn[];
};

const NotificationMasterColumns = (moduleId: number, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%"
    },
    {
      align: "left",
      title: "Notification Key",
      dataIndex: "notification_key",
      key: "notification_key",
      sorter: {
        compare: TableHelper.valueCompare("notification_key")
      },
      render: (text, record) => <div className="wordWrapWordBreak">{rowId === record.id && (actionType === Actions.DELETE || actionType === Actions.EDIT) ? renderText(text) : text ?? ""}</div>
    },
    {
      align: "left",
      title: "Notification Type",
      dataIndex: "notification_type",
      key: "notification_type",
      sorter: {
        compare: TableHelper.valueCompare("notification_type")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Notification Subject",
      dataIndex: "notification_subject",
      key: "notification_subject",
      sorter: {
        compare: TableHelper.valueCompare("notification_subject")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Notification Body",
      dataIndex: "notification_body",
      key: "notification_body",
      sorter: {
        compare: TableHelper.valueCompare("notification_body")
      },
      render: renderTextContainer
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: {
        compare: TableHelper.valueCompare("is_active")
      },
      render: (text, record) => <div>{text === true ? <Tag color="success">Active</Tag> : <Tag color="error">In-Active</Tag>}</div>
    },
    {
      align: "left",
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      render: (text, record) => {
        return <CommonActionComponent handleRowIdAndActionType={handleRowIdAndActionType} record={record} moduleId={moduleId} />;
      }
    }
  ] as TableColumn[];
};

const AdvanceBookingQuotaMasterColumns = (moduleId: number, handleRowIdAndActionType: FixMeLater, rowId: number | null, actionType: string | null) => {
  return [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      render: renderNumberValue,
      width: "5%"
    },
    {
      align: "left",
      title: "Vehicle Type",
      dataIndex: "vehicle_type_name",
      key: "vehicle_type_name",
      sorter: {
        compare: TableHelper.valueCompare("vehicle_type_name")
      },
      render: (text, record) => <div className="wordWrapWordBreak">{rowId === record.id && (actionType === Actions.DELETE || actionType === Actions.EDIT) ? renderText(text) : text ?? ""}</div>
    },
    {
      align: "center",
      title: "Advance Booking Quota",
      dataIndex: "advance_booking_quota",
      key: "advance_booking_quota",
      sorter: {
        compare: TableHelper.digitSorter("advance_booking_quota")
      },
      render: TableHelper.renderText
    },
    {
      align: "lef",
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      render: (text, record) => {
        return <CommonActionComponent handleRowIdAndActionType={handleRowIdAndActionType} record={record} moduleId={moduleId} />;
      }
    }
  ] as TableColumn[];
};

const useGenerateColumns = (moduleId: number) => {
  /* CONSTANTS */
  let columns;
  const BASE_IMAGE_PATH = process.env.REACT_APP_BASE_IMAGE_PATH as string;

  /* STATE */
  const [rowId, setRowId] = useState<number | null>(null);
  const [rowData, setRowData] = useState<FixMeLater>(null);
  const [actionType, setActionType] = useState<string | null>(null);
  const [imagePath, setImagePath] = useState<string | null>(null);

  /* HANDLERS */
  const handleSetImagePath = (value: string | null) => {
    setImagePath(`${BASE_IMAGE_PATH}/${value}`);
  };

  const handleResetImagePath = () => {
    setImagePath(null);
  };

  const handleRowIdAndActionType = (rowId: number, actionType: string, record: FixMeLater) => {
    setRowId(rowId);
    setActionType(actionType);
    setRowData(record);
  };

  const handleClearRowIdAndActionType = () => {
    setRowId(null);
    setActionType(null);
    setRowData(null);
  };

  switch (moduleId) {
    case ModuleAndIdMapping[Modules.ROLE_MASTER]:
      columns = RoleMasterColumns(moduleId, handleRowIdAndActionType, rowId, actionType);
      break;
    case ModuleAndIdMapping[Modules.CONFIG_MASTER]:
      columns = ConfigMasterColumns(moduleId, handleRowIdAndActionType, rowId, actionType);
      break;
    case ModuleAndIdMapping[Modules.WEB_FE_ACCESS_CONTROL_MASTER]:
      columns = AccessControlMasterColumns(moduleId, handleRowIdAndActionType, rowId, actionType);
      break;
    case ModuleAndIdMapping[Modules.CUSTOMER_MASTER]:
      columns = CustomerMasterColumns(moduleId, handleSetImagePath, handleRowIdAndActionType, rowId, actionType);
      break;
    case ModuleAndIdMapping[Modules.LOCATION_TYPE_MASTER]:
      columns = LocationTypeMasterColumns(moduleId, handleRowIdAndActionType, rowId, actionType);
      break;
    case ModuleAndIdMapping[Modules.PARKING_MAP_TYPE_MASTER]:
      columns = ParkingMapTypeMasterColumns(moduleId, handleRowIdAndActionType, rowId, actionType);
      break;
    case ModuleAndIdMapping[Modules.CUSTOMER_LOCATION_MASTER]:
      columns = CustomerLocationMasterColumns(moduleId, handleRowIdAndActionType, rowId, actionType);
      break;
    case ModuleAndIdMapping[Modules.CUSTOMER_CLIENT_MASTER]:
      columns = CustomerClientMasterColumns(moduleId, handleRowIdAndActionType, rowId, actionType);
      break;
    case ModuleAndIdMapping[Modules.KEY_FOB_MASTER]:
      columns = KeyFobMasterColumns(moduleId, handleRowIdAndActionType, rowId, actionType);
      break;
    case ModuleAndIdMapping[Modules.KEY_FOB_ALLOCATION_MASTER]:
      columns = KeyFobAllocationMasterColumns(moduleId, handleRowIdAndActionType, rowId, actionType);
      break;
    case ModuleAndIdMapping[Modules.PRICING_MASTER]:
      columns = PricingMasterColumns(moduleId, handleRowIdAndActionType, rowId, actionType);
      break;
    case ModuleAndIdMapping[Modules.FAQ_MASTER]:
      columns = FaqMasterColumns(moduleId, handleRowIdAndActionType, rowId, actionType);
      break;
    case ModuleAndIdMapping[Modules.NOTIFICATION_MASTER]:
      columns = NotificationMasterColumns(moduleId, handleRowIdAndActionType, rowId, actionType);
      break;
    case ModuleAndIdMapping[Modules.ADVANCE_BOOKING_QUOTA_MASTER]:
      columns = AdvanceBookingQuotaMasterColumns(moduleId, handleRowIdAndActionType, rowId, actionType);
      break;
    default:
      break;
  }

  return { columns, rowId, actionType, rowData, handleClearRowIdAndActionType, imagePath, handleResetImagePath };
};

export default useGenerateColumns;
